import { Flex, IconButton } from '@chakra-ui/react';
import { MdEdit } from 'react-icons/md';

import { TableColumn } from '@app/components/common/table';
import { UserInfo } from '@app/api/models';
import { Employee } from '@app/api/models/structure';
import { Txt } from '@app/components/common';

export const useColumns = ({
  onEdit,
}: {
  onEdit: (item: Employee) => void;
}): TableColumn<Employee>[] => {
  return [
    {
      name: 'id',
      label: '#',
      options: {
        filter: false,
        sort: false,
      },
    },
    {
      name: 'name',
      label: 'ФИО',
      options: {
        filter: {
          name: 'name',
          type: 'text',
        },
        sort: false,
        customBodyRender: (value: string) => {
          return <Txt>{value}</Txt>;
        },
      },
    },
    {
      name: 'user',
      label: 'Пользователь',
      options: {
        filter: {
          label: 'Пользователь (по ФИО)',
          name: 'full_name',
          type: 'text',
        },
        sort: false,
        customBodyRender: (value: UserInfo) => {
          if (!value) {return <Txt textColor='gray.500'>(пусто)</Txt>;}
          return <Txt>{value?.full_name} [{value?.username}]</Txt>;
        },
      },
    },
    {
      name: 'id',
      label: 'Действия',
      options: {
        filter: false,
        sort: false,
        customBodyRender: (id, { rowData }) => {
          return (
            <Flex gap={2}>
              <IconButton name="edit" onClick={() => onEdit(rowData)} aria-label="edit" size='sm'>
                <MdEdit />
              </IconButton>
            </Flex>
          );
        },
      },
    },
    {
      name: 'is_active',
      label: 'Активность',
      options: {
        hidden: true,
        filter: {
          name: 'is_active',
          type: 'boolean',
        },
        sort: false,
      },
    }
  ];
};  